/*
 * @Descripttion: useSelect(原mixin)  类型待优化
 * @version:
 * @Author: June
 * @Date: 2023-04-23 21:10:05
 * @LastEditors: 秦少卫 nihaojob@163.com
 * @LastEditTime: 2025-08-14 10:44:11
 */
import { inject, computed, reactive, onMounted, onBeforeMount } from 'vue';
import EventEmitter from 'events';
import { uniqBy } from 'lodash-es';
import Editor, { EventType } from '@kuaitu/core';
import { v4 as uuid } from 'uuid';
const { SelectMode, SelectEvent } = EventType;

import { getUserInfo } from '@/api/user';

import { useI18n } from 'vue-i18n';

export default function useSelect(matchType?: Array<string>) {
  const { t } = useI18n();
  const fabric = inject('fabric');
  const canvasEditor = inject('canvasEditor') as Editor;
  const appEmit = inject('appEmit') as EventEmitter;
  const podEditor = inject('podEditor', null) as any;

  const state = reactive({
    mSelectMode: SelectMode.EMPTY,
    mSelectOneType: '',
    mSelectTypes: [] as any, // 选择type
    mSelectId: '' as any, // 选择id
    mSelectIds: [] as any, // 选择id
    mSelectActive: [] as fabric.Object[],
  });
  const selectOne = (arr: fabric.Object[]) => {
    state.mSelectMode = SelectMode.ONE;
    const [item] = arr;
    if (item) {
      state.mSelectActive = [item];
      state.mSelectId = item.id;
      state.mSelectOneType = item.type;
      state.mSelectTypes = [item.type];
      state.mSelectIds = [item.id];
    }
    callBack();
  };

  const selectMulti = (arr: fabric.Object[]) => {
    state.mSelectMode = SelectMode.MULTI;
    state.mSelectId = '';
    state.mSelectIds = arr.map((item) => item.id);
    state.mSelectTypes = arr.map((item) => item.type);
    callBack();
  };

  const selectCancel = () => {
    state.mSelectId = '';
    state.mSelectIds = [];
    state.mSelectTypes = [];
    state.mSelectMode = SelectMode.EMPTY;
    state.mSelectOneType = '';
    callBack();
  };

  let callBack = () => {
    //
  };
  const getObjectAttr = (cb: any) => {
    callBack = cb;
  };
  onMounted(() => {
    if (canvasEditor) {
      canvasEditor.on(SelectEvent.ONE, selectOne);
      canvasEditor.on(SelectEvent.MULTI, selectMulti);
      canvasEditor.on(SelectEvent.CANCEL, selectCancel);
    }
  });

  onBeforeMount(() => {
    if (canvasEditor) {
      canvasEditor.off(SelectEvent.ONE, selectOne);
      canvasEditor.off(SelectEvent.MULTI, selectMulti);
      canvasEditor.off(SelectEvent.CANCEL, selectCancel);
    }
  });

  let isMatchType;
  if (matchType) {
    isMatchType = computed(() => matchType.includes(state.mSelectOneType));
  }
  const isOne = computed(() => state.mSelectMode === 'one');
  const isMultiple = computed(() => state.mSelectMode === 'multiple');
  const isGroup = computed(() => state.mSelectMode === 'one' && state.mSelectOneType === 'group');
  const isImage = computed(() => state.mSelectMode === 'one' && state.mSelectOneType === 'image');
  const isCurvedText = computed(
    () => state.mSelectMode === 'one' && state.mSelectOneType === 'curved-text'
  );
  const isSelect = computed(() => state.mSelectMode);

  const selectType = computed(() => state.mSelectOneType);

  const matchTypeHander = (types: string[]) => {
    return computed(() => types.includes(state.mSelectOneType));
  };
  const matchTypeInclude = (types: string[]) => {
    for (const item of state.mSelectTypes) {
      if (types.includes(item)) {
        return true;
      }
    }
    return false;
  };

  // 检查是否登录并弹框
  const isLogin = ref(false);
  const checkAndShowLogin = (showLogin = true) => {
    return new Promise((resolve, reject) => {
      getUserInfo()
        .then((res) => {
          isLogin.value = true;
          resolve(res);
        })
        .catch(() => {
          reject();
          isLogin.value = false;
          showLogin && appEmit.emit('showLogin');
        });
    });
  };

  const getListWithOutSelf = (selfId: string) => {
    const list = ref<any[]>([]);
    // 不改原数组 反转
    list.value = [
      ...(canvasEditor.canvas?.getObjects() || []).filter((item: any) => {
        // 过滤掉辅助线
        return !(
          item instanceof (window as any).fabric.GuideLine ||
          item.id === 'workspace' ||
          item.clipId ||
          item.id === selfId
        );
      }),
    ].map((item) => {
      const { type, id, name, text, hasControls, visible } = item;
      if (!id) {
        item.id = uuid();
      }
      return {
        type,
        id,
        name,
        text,
        visible,
        hasControls,
        // objects: _objects,
      };
    });
    list.value = uniqBy(unref(list), 'id');
    return list.value;
  };

  return {
    fabric,
    canvasEditor,
    mixinState: state,
    selectType,
    isSelect,
    isGroup,
    isOne,
    isImage,
    isCurvedText,
    isMultiple,
    isMatchType,
    matchTypeHander,
    getObjectAttr,
    appEmit,
    t,
    isLogin,
    checkAndShowLogin,
    matchTypeInclude,
    getListWithOutSelf,
    podEditor,
  };
}
